import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import * as t from 'io-ts';
import GENDER from '../enums/gender';

export const UserProfilePersonalityType = t.interface({
    gender: t.union([t.string, t.null, t.undefined]),
    avatarId: t.union([t.string, t.null, t.undefined]),
    lastName: t.union([t.string, t.null, t.undefined]),
    birthday: t.union([t.string, t.null, t.undefined]),
    firstName: t.union([t.string, t.null, t.undefined]),
    middleName: t.union([t.string, t.null, t.undefined]),
});

export interface UserProfilePersonalityDto extends t.TypeOf<typeof UserProfilePersonalityType> {
}

class UserProfilePersonality {
    avatarId: string | null;
    lastName: string | null;
    birthday: string | null;
    firstName: string | null;
    middleName: string | null;
    gender: SimpleObjectInterface | null;

    constructor(params: UserProfilePersonalityDto) {
        this.gender = !!params.gender
            ? GENDER[params.gender]
            : null;
        this.birthday = params.birthday ?? null;
        this.avatarId = params.avatarId ?? null;
        this.lastName = params.lastName ?? null;
        this.firstName = params.firstName ?? null;
        this.middleName = params.middleName ?? null;
    }
}

export default UserProfilePersonality;
